<template>
  <div class="user_profiles_video">
    <SkeletonScreen v-if="!isCloseSkeletonScreen" :data="2" />
    <div v-if="isCloseSkeletonScreen">
      <div v-if="videoList.length">
        <dl
          class="profiles_video_item"
          v-for="(video,index) in videoList"
          :key="index"
          @click="$downapppop.open"
        >
          <dt class="v_cover">
            <img :src="video.v_cover" v-if="video.v_cover" />
            <div class="no_img" v-else-if="!video.v_cover">爱股票</div>
            <div class="play_btn">
              <img :src="require('@/assets/images/icon-play-btn@2x.png')" alt />
            </div>
          </dt>
          <dd class="v_detail">
            <h4 class="title_short">{{video.title_short}}</h4>
            <p class="v_num">
              <span>{{ video.v_num }}个视频</span>
              <span v-if="0">播放量：{{video.play_num}}</span>
            </p>
            <div v-if="video.is_free === '1'" class="free_video">免费</div>
            <div v-if="video.is_free !== '1'" class="no_free_video">
              <div class="discount" v-if="0 && video.price_intro">{{video.price_intro}}</div>
              <div v-if="video.vip_unshared === 'no'">
                <p class="discount_price">￥{{video.discount_price}}</p>
                <p class="original_price" v-if="0 && video.price !== '0'">￥{{video.price}}</p>
              </div>
            </div>
          </dd>
        </dl>
      </div>
      <no-result v-if="!videoList.length" title="此用户没有发布内容"></no-result>
      <no-data msg="已经到底了~" v-if="videoList.length&&!hasMore"></no-data>
      <loading
        class="loadbox"
        style="padding: 12px 0;"
        loadType="small"
        :title="'正在加载中...'"
        v-if="videoList.length&&listLoading"
      ></loading>
    </div>
  </div>
</template>
<script>
import UserProfilesApi from "@/api/userProfiles/";
import noResult from "@/base/no-result/";
import noData from "@/base/nodata/";

export default {
  name: "UserProfiles",
  components: {
    noResult,
    noData
  },
  computed: {
    userInfo() {
      return this.$store.state.userProfiles.userInfo;
    }
  },
  data() {
    return {
      videoList: [],
      live: {},
      user_id: parseInt(this.$route.params.id),
      isCloseSkeletonScreen: false,
      pullup: true,
      beforeScroll: true,
      hasMore: true,
      listLoading: true,
      page: 1,
      before: "",
      randomStr: Math.random()
        .toString(36)
        .slice(-4)
    };
  },
  created() {
    this.getVideoList();
  },
  methods: {
    columnListMore() {
      if (!this.hasMore) return;
      if (this.listLoading) return;
      this.getVideoList();
    },
    //老师个人主页  视频
    async getVideoList() {
      this.listLoading = true;
      let res = await UserProfilesApi.getVideoList(this.user_id, this.before);
      if (res.data && res.data.length) {
        if (this.before) {
          this.videoList = this.videoList.concat(res.data);
        } else {
          this.videoList = res.data;
        }
        this.before = this.videoList[this.videoList.length - 1].display_order;
      } else {
        this.hasMore = false;
      }

      this.isCloseSkeletonScreen = true;
      this.listLoading = false;
    }
  }
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@color-red: #fe484a; //主色
@color-red-high: #c7000a; //特殊情况
@color-green: #0ac890; //主色
@color-blue: #1d88d0; //全文、超链接颜色
@color-gray-small: #f7f7f7; //转发内容背影色

@color-gray-high: #222222;
@color-gray-middle: #636363;
@color-gray-low: #939393;

.border-1px(@color: #ccc, @radius: 0px, @style: solid) {
  position: relative;

  &::after {
    content: "";
    pointer-events: none;
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    transform-origin: 0 0;
    border-bottom: 1px @style @color;
    border-radius: @radius;
    box-sizing: border-box;
    width: 100%;
    height: 100%;

    @media (min-resolution: 2dppx) {
      width: 200%;
      height: 200%;
      border-radius: @radius * 2;
      transform: scale(0.5);
    }

    @media (min-resolution: 3dppx) {
      width: 300%;
      height: 300%;
      border-radius: @radius * 3;
      transform: scale(0.333);
    }
  }
}

.recommend {
  position: fixed;
  overflow: auto;
  top: 48px;
  width: 100%;
  padding-bottom: 50px;
  bottom: 0;
  background-color: #f0f0f0;
}

.recommend-content {
  height: 100%;
  overflow: hidden;
}

.user_profiles_video {
  .profiles_video_item {
    background: #ffffff;
    .border-1px();
    padding: 12px 12px;
    display: flex;

    .v_cover {
      width: 135px;
      height: 80px;
      flex-shrink: 0;
      position: relative;
      > img {
        width: 100%;
        height: 100%;
        border-radius: 5px;
      }
      > .no_img {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #999999;
        background: #cccccc;
      }
      .play_btn {
        position: absolute;
        width: 30px;
        height: 30px;
        top: 50%;
        left: 50%;
        margin-left: -15px;
        margin-top: -15px;
        > img {
          width: 100%;
          height: 100%;
          display: block;
        }
      }
    }

    .v_detail {
      height: 77px;
      display: flex;
      flex: 1;
      flex-direction: column;
      justify-content: space-around;
      padding-left: 11px;

      > h4.title_short {
        font-size: 15px;
        color: @color-gray-high;
        font-weight: 400;

        overflow: hidden;
        max-width: 55vw;
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .v_num {
        font-size: 13px;
        color: @color-gray-low;

        > span {
          margin-right: 11px;
        }
      }

      //免费视频
      .free_video {
        display: flex;
        padding: 0 5px;
        width: max-content;
        height: 20px;
        justify-content: center;
        align-items: center;
        flex-shrink: 0;
        color: #FE484A;
        font-size: 12px;
        border-radius: 4px;
        border: 0.5px solid #FF4644;
      }

      //收费视频
      .no_free_video {
        //height: 26px;
        display: flex;
        align-items: center;

        .discount {
          height: 26px;
          // width: 86px;
          padding: 0 7px;
          background: #ff6848;
          color: #ffffff;
          font-size: 13px;
          text-align: center;
          line-height: 26px;
          border-radius: 2px;
        }

        .discount_price {
          //margin-left: 7px;
          color: #FF443D;
          font-size: 14px;
        }

        .original_price {
          margin-left: 13px;
          font-size: 13px;
          color: @color-gray-low;
          text-decoration: line-through;
          //display: none;
        }
      }
    }
  }
}
</style>